import { ErrorMessage, useFormikContext } from 'formik'
import { FC } from 'react'
import { Message } from 'rsuite'
import './formikErrorMessage.scss'

type Props = {
  name: string
}

const FormikErrorMessage: FC<Props> = ({ name }) => {
  const formikContext = useFormikContext()

  if (!formikContext) {
    return null
  }

  const renderFormError = (errorMessage: string): JSX.Element | null => {
    return errorMessage ? (
      <Message type="error" showIcon>
        {errorMessage}
      </Message>
    ) : null
  }

  return (
    <div role="alert" aria-live="polite">
      <ErrorMessage name={name} render={renderFormError} />
    </div>
  )
}

export default FormikErrorMessage
